/** @format */

import React, { useEffect, useState } from 'react'
import {
  _$,
  Button,
  Dialog,
  Icon,
  Message,
  Pagination,
  Table,
  TableColumn,
  Tag
} from '@king-design/react'
import { useHistory } from 'react-router'
import { MonitorSearch } from 'src/components'
import styled from 'styled-components'
import { PageProps, initPage } from 'src/utils/interface'
import { StatusEnum } from './variables'
import { getScheduleList, deleteSchedule } from 'src/api/ApiContacts'
import { useAsyncFn } from 'react-use'

interface SearchProps extends PageProps {
  Query: string
}
const initSearch: SearchProps = {
  Query: '',
  ...initPage
}
const Schedule: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const [search, setSearch] = useState<SearchProps>(initSearch)

  // 获取列表
  const [{ value: tableData }, fetch] = useAsyncFn(
    async (params?) => {
      const result = await getScheduleList({
        ...search,
        ...params
      })
      return {
        data: result?.List || [],
        total: result?.TotalCount || 0
      }
    },
    [search]
  )

  // 删除策略/删除规则
  const [, deleteFetch] = useAsyncFn(
    async id => {
      const result = await deleteSchedule(id)
      if (result?.code === 'Success') {
        Message.success(_$('删除成功'))
        setSearch({
          ...search,
          Page: 1
        })
      } else {
        result?.message && Message.error(result?.message)
      }
    },
    [search]
  )

  useEffect(() => {
    fetch()
  }, [search])

  return (
    <div className={className}>
      <div className="header">
        <Button
          type="primary"
          onClick={() => history.push(`/monitor/alarmServer/alertTarget/schedule/edit`)}
        >
          <Icon className="ion-plus-round" />
          {_$('新建值班表')}
        </Button>
        <MonitorSearch
          placeholder={_$('搜索关键词')}
          value={search.Query}
          onChange={value => {
            setSearch({
              ...search,
              Query: value,
              Page: 1
            })
          }}
        />
      </div>
      <Table
        stickHeader={50}
        data={tableData?.data}
        rowKey={data => data.ScheduleID}
        checkType="none"
        animation={false}
        className="marginTop"
      >
        <TableColumn
          key="Name"
          title={_$('值班表名称')}
          slotTemplate={([data]) => {
            return (
              <a
                onClick={() => {
                  data?.ScheduleID &&
                    history.push(
                      `/monitor/alarmServer/alertTarget/schedule/edit?id=${data.ScheduleID}`
                    )
                }}
              >
                {data.Name}
              </a>
            )
          }}
        />
        <TableColumn key="ChangeTime" title={_$('换班时间')} width={100} />
        <TableColumn
          key="Period"
          title={_$('值班周期')}
          width={100}
          slotTemplate={([data]) => {
            return <span>{data.Period === 'day' ? _$('按天') : _$('按周')}</span>
          }}
        />
        <TableColumn
          key="CurrentPerson"
          title={_$('当前值班人')}
          slotTemplate={([{ CurrentPerson }]) => {
            return (
              CurrentPerson?.map((item, index) => {
                return (
                  <span key={item.userid}>
                    {item.nickname}
                    {index !== CurrentPerson?.length - 1 ? '、' : ''}
                  </span>
                )
              }) || '-'
            )
          }}
        />
        <TableColumn
          key="Description"
          title={_$('描述')}
          slotTemplate={([data]) => {
            return <span>{data.Description || '-'}</span>
          }}
        />
        <TableColumn
          key="Status"
          title={_$('状态')}
          width={100}
          slotTemplate={([data]) => {
            if (StatusEnum[data.Status]) {
              if (data.Status === 'active') {
                return <Tag type="success">{StatusEnum[data.Status]}</Tag>
              } else {
                return <Tag disabled>{StatusEnum[data.Status]}</Tag>
              }
            } else {
              return '-'
            }
          }}
        />
        <TableColumn
          key="StartTime"
          title={_$('开始时间')}
          width={150}
          slotTemplate={([data]) => {
            return <span>{data.StartTime || '-'}</span>
          }}
        />
        <TableColumn
          key="EndTime"
          title={_$('结束时间')}
          width={150}
          slotTemplate={([data]) => {
            return <span>{data.EndTime || '-'}</span>
          }}
        />
        <TableColumn
          key="active"
          title={_$('操作')}
          width={100}
          slotTemplate={([data]) => {
            const { Name, ScheduleID } = data
            return (
              <a
                onClick={async () => {
                  let dialog: Dialog
                  ScheduleID &&
                    Dialog.confirm({
                      title: Name,
                      content: _$('确认删除所选的值班表吗'),
                      ref: _dialog => (dialog = _dialog),
                      okText: _$('确认删除'),
                      ok: async () => {
                        dialog.showLoading()
                        await deleteFetch(ScheduleID)
                        dialog.close()
                      }
                    })
                }}
              >
                {_$('删除')}
              </a>
            )
          }}
        />
      </Table>
      <Pagination
        value={search.Page}
        limit={search.PageSize}
        total={tableData?.total || 0}
        size="small"
        onChangeValue={value => {
          setSearch({
            ...search,
            Page: value
          })
        }}
        onChangeLimit={limit => {
          setSearch({
            ...search,
            PageSize: limit
          })
        }}
      />
    </div>
  )
}
export default styled(Schedule)``
